export const APP_NAME = 'Dashboard Thông Minh';

export const TOKEN_KEY = 'auth_token';
export const REFRESH_TOKEN_KEY = 'auth_refresh_token';
/** Đặt sau khi đăng nhập thành công; dùng để không gọi POST /api/auth/refresh khi khách chưa từng có phiên (refresh HttpOnly vẫn khôi phục được sau lần đăng nhập đầu). */
export const AUTH_SESSION_PROBE_KEY = 'ies_auth_session_probe';
/** Lưu UUID thiết bị cho header `X-Device-Id` (login / refresh / logout). */
export const DEVICE_ID_KEY = 'ies_device_id';

export const API_TIMEOUT = 30000;

/** Khớp `MAX_UPLOAD_MB` trong netcdf-ingestion (500). */
export const NETCDF_MAX_UPLOAD_BYTES = 500 * 1024 * 1024;
/** Upload file lớn — vượt `API_TIMEOUT` mặc định. */
export const NETCDF_UPLOAD_TIMEOUT_MS = 10 * 60 * 1000;

export const AUTH = {
  MAX_LOGIN_ATTEMPTS: 5,
  LOCKOUT_DURATION_MS: 15 * 60 * 1000, // 15 minutes
  /** Idle period after the last failed attempt (while not locked); then reset attempt count to 0. */
  FAILED_ATTEMPTS_DECAY_MS: 15 * 60 * 1000,
  SESSION_DURATION_MS: 24 * 60 * 60 * 1000, // 24 hours
  REMEMBER_ME_DURATION_MS: 7 * 24 * 60 * 60 * 1000, // 7 days
  BRUTE_FORCE_KEY: 'auth_brute_force',
  /** Gọi refresh trước khi access JWT hết hạn (tránh văng route do `exp`). */
  PROACTIVE_REFRESH_BEFORE_EXP_MS: 2 * 60 * 1000,
} as const;

export const NETWORK = {
  /** Bật mới gọi `generate_204` theo chu kỳ; tắt để không poll Google liên tục. */
  ENABLE_PERIODIC_CONNECTIVITY_CHECK: false,
  CHECK_INTERVAL_MS: 5000,
  TIMEOUT_MS: 5000,
} as const;

export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_PAGE_SIZE: 20,
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
} as const;

export const DEBOUNCE_MS = 300;

export const REALTIME = {
  RECONNECT_INTERVAL: 3000,
  MAX_RECONNECT_ATTEMPTS: 10,
  DATA_BUFFER_SIZE: 10000,
} as const;
